module.exports = __webpack_public_path__ + "img/Zombie.a0523af2.png";